// @owners { team: patients }
import {
  ActionSheetContext,
  ActionSheetV2,
  Button,
  InputText,
  LgPadding,
  Toast,
  ToastContext,
} from '@alto/design-system';
import React, { useContext, useState } from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

type Props = {
  readonly params: {
    query_string?: string;
    shipment_id?: number | null;
    facility_id?: number;
    origin?: string;
  };
};

export const SuggestEssentialsActionSheet = ({ params: baseParams }: Props) => {
  const { addToast } = useContext(ToastContext);
  const { closeActionSheet } = useContext(ActionSheetContext);
  const [feedback, setFeedback] = useState('');
  const { trackEvent } = useAnalytics();
  const params = {
    ...baseParams,
    feedback,
  };

  const onFeedbackChange = (value: string) => {
    setFeedback(value);
  };

  const handleFeedbackSubmit = () => {
    trackEvent({ event: EVENTS.ESSENTIALS__SEARCH_FEEDBACK_FORM_SUBMITTED, params });
    addToast(<Toast>Thank you for suggesting items!</Toast>);
    closeActionSheet();
  };

  return (
    <ActionSheetV2
      title="What item(s) would you like to see in the Essentials store (products, brands, etc.)?"
      buttons={[
        <Button
          key="submit"
          onPress={handleFeedbackSubmit}
          disabled={!feedback.length}
        >
          Submit
        </Button>,
      ]}
    >
      <LgPadding>
        <InputText
          value={feedback}
          onChangeText={onFeedbackChange}
          placeholder="Type feedback here"
          multiline
        />
      </LgPadding>
    </ActionSheetV2>
  );
};
